import styled, { css } from 'styled-components';
import { focusVisibleWithOutline } from '../utils/focus-indicator';
const inheritStyle = ({
  'data-inherit': inherit
}) => `
  ${inherit ? `font-size: inherit;` : ''}
  ${inherit ? `line-height: inherit;` : ''}
`;
const textColorStyle = ({
  'data-inherit': inherit,
  theme
}) => `
  color: ${inherit ? 'inherit' : theme.palette.content};
`;
const textFontWeightStyle = ({
  'data-inherit': inherit
}) => `
  font-weight: ${inherit ? 'inherit' : '500'};
`;
const textLinkCss = css`
  ${inheritStyle};
  ${textColorStyle};
  ${textFontWeightStyle};
  border-bottom: 1px ${({
  'data-dashed': dashed
}) => dashed ? 'dashed' : 'solid'}
    ${props => props.theme.palette.actionableSecondary};
  text-decoration: none;
  transition: color 0.2s ease-out;

  &:active,
  &:hover,
  &:focus {
    text-decoration: none;
    color: ${props => props.theme.palette.actionableSecondary};
  }
`;
const unstyledLinkCss = css`
  ${inheritStyle};
  &,
  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;
const noUnderlineCss = css`
  text-decoration: none;
`;
const typeCss = {
  unstyled: unstyledLinkCss,
  text: textLinkCss,
  default: '',
  'no-underline': noUnderlineCss
};
export default styled.a`
  ${props => typeCss[props['data-type']]};
  ${({
  $bold
}) => $bold ? css`
          font-weight: 500;
        ` : ''}

  ${focusVisibleWithOutline({
  offset: 'default',
  radius: 'default'
})}
`;
//# sourceMappingURL=styles.js.map